import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { buttonTheme } from './button-theme';
import type { LegacyButtonSize } from './button-type';

export const buttonFocusStyle = css`
  position: relative;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px white, 0 0 0 4px ${theme.colors.primary50};
  }

  &:focus:not(:active)::before,
  &:focus-within:not(:active)::before {
    opacity: 1;
  }
`;

export const buttonBaseStyle = css`
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-family: ${theme.font.family};
  position: relative;
  text-transform: capitalize;

  &:disabled {
    cursor: default;
  }
`;

export const baseButtonStyles: Record<LegacyButtonSize, string> = {
  large: css`
    width: 100%;
    height: ${buttonTheme.large.height}px;
    font-size: ${theme.fontSize(buttonTheme.large.fontSize)};
    line-height: ${buttonTheme.large.lineHeight};
    padding: ${buttonTheme.large.padding};
  `,
  medium: css`
    width: 100%;
    height: ${buttonTheme.medium.height}px;
    font-size: ${theme.fontSize(buttonTheme.medium.fontSize)};
    line-height: ${buttonTheme.medium.lineHeight};
    padding: ${buttonTheme.medium.padding};
  `,
  small: css`
    width: 100%;
    height: ${buttonTheme.small.height}px;
    font-size: ${theme.fontSize(buttonTheme.small.fontSize)};
    line-height: ${buttonTheme.small.lineHeight};
    padding: ${buttonTheme.small.padding};
  `,
  tiny: css`
    width: auto;
    height: ${buttonTheme.tiny.height}px;
    font-size: ${theme.fontSize(buttonTheme.tiny.fontSize)};
    line-height: ${buttonTheme.tiny.lineHeight};
    padding: ${buttonTheme.tiny.padding};
  `,
};
